import React from "react";
import TableHeadingChip from "../TableHeadingChip";
import { Disclosure } from "@headlessui/react";
import TableRow from "../TableRow";
import TableGroup from "./TableGroup";
const TablePZChart = () => {
  return (
    <div className="w-full pt-8 overflow-x-auto max-w-full custom-dashboard-table-container">
      <div className="w-full mx-auto bg-white rounded-2xl  flex flex-col  custom-dashboard-table">
        <div className="flex -mb-8  ml-8">
          <div className="table-left-content"></div>
          <TableHeadingChip text="GeoZone" />
          <TableHeadingChip text="ArcGIS Urban" />
          <TableHeadingChip text="GeoComment" />
          <TableHeadingChip text="ArcGIS Hub" />
          <TableHeadingChip text="GeoLocator" />
          <TableHeadingChip text="Business Analyst" />
          <TableHeadingChip text="3D Basemaps" />
        </div>
        <Disclosure defaultOpen={true}>
          {({ open }) => (
            <TableGroup
              title="Daily Use"
              isOpen={open}
              isFirst={true}
              
            >
              <TableRow
                content={{
                  title: "Level of technical knowledge required to operate",
                  values: ["Easy", "Advance", "Easy", "Medium", "Medium", "Advance", "Advance"],
                }}
              />
              <TableRow
                content={{
                  title: "Designed for daily operation based on ease of use, simple to operate and require little or no technical training.",
                  values: [true, false, true, false, true, false, false],
                }}
              />             
            </TableGroup>
          )}
        </Disclosure>
        <Disclosure defaultOpen={true}>
          {({ open }) => (
            <TableGroup
              title="Zoning &amp; Spatial Analysis"
              isOpen={open}
            >
              <TableRow
                content={{
                  title: "3D enabled spatial analysis",
                  values: [true, true, false, false, false, false, false],
                }}
              />
              <TableRow
                content={{
                  title: "Accurately analyze zoning ordinances",
                  values: [true, true, false, false, false, false, false],
                }}
              />
              <TableRow
                content={{
                  title: "Create, edit and manage Land Use and Scenario Plans",
                  values: [false, true, false, false, false, false, true],
                }}
              />
              <TableRow
                content={{
                  title: "Measure impacts as you plan",
                  values: [false, true, false, false, false, false, false],
                }}
              />
              <TableRow
                content={{
                  title: "Customize building types for analytical purposes",
                  values: [false, true, false, false, false, false, false],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Create custom procedural rules to articulate 3D architectural ideas",
                  values: [false, true, false, false, false, false, true],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Linked ordinance text and real-time zoning data thorugh customized application",
                  values: [true, false, false, false, false, false, false],
                }}
              />
              <TableRow
                content={{
                  title: "Tools for site selection and market analysis",
                  values: [true, false, false, false, true, true, false],
                }}
              />
              <TableRow
                content={{
                  title: "Data-driven decision-making for economic development",
                  values: [true, false, false, false, true, true, false],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Access to ESRI curated demographic and tapestry segmentation data",
                  values: [true, false, false, false, true, true, false],
                }}
              />
            </TableGroup>
          )}
        </Disclosure>
        <Disclosure defaultOpen={true}>
          {({ open }) => (
            <TableGroup title="Visualization" isOpen={open}>
              <TableRow
                content={{
                  title: "3D Visualization",
                  values: [true, true, false, false, false, false, true],
                }}
              />
              <TableRow
                content={{
                  title: "Access to 3D under/above ground utility mapping",
                  values: [true, true, false, false, false, false, true],
                }}
              />
              <TableRow
                content={{
                  title: "Sketch quick 3D concepts",
                  values: [true, true, false, false, false, false, false],
                }}
              />
              <TableRow
                content={{
                  title: "Creating a digital twin",
                  values: [true, true, false, false, false, false, true],
                }}
              />
              <TableRow
                content={{
                  title: "Simple to use one-stop visualization application",
                  values: [true, true, false, false, false, false, false],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Real-time link between codified Zoning ordinances and GIS",
                  values: [true, false, false, false, false, false, false],
                }}
              />
              <TableRow
                content={{
                  title: "Access multi-departmental data into one application",
                  values: [true, true, false, false, false, false, false],
                }}
              />
            </TableGroup>
          )}
        </Disclosure>
        <Disclosure defaultOpen={true}>
          {({ open }) => (
            <TableGroup title="Engagement" isOpen={open}>
              <TableRow
                content={{
                  title: "Create and manage Planning initiatives",
                  values: [false, false, true, true, false, false, false],
                }}
              />
              <TableRow
                content={{
                  title: "Enable digital engagement",
                  values: [false, true, true, true, false, false, false],
                }}
              />
              <TableRow
                content={{
                  title: "Community Engagement Dashboards",
                  values: [false, false, false, true, false, false, false],
                }}
              />
              <TableRow
                content={{
                  title: "Initiative Team Management",
                  values: [false, false, false, true, false, false, false],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Integrate event management, surveys, data collection all in one platform",
                  values: [false, false, false, true, false, false, false],
                }}
              />
              <TableRow
                content={{
                  title: "Map-based collaborative engagement",
                  values: [false, true, true, true, false, false, false],
                }}
              />
            </TableGroup>
          )}
        </Disclosure>
      </div>
    </div>
  );
};

export default TablePZChart;
